export const sendSmsZh = {
  tipsTitle: '温馨提示',
  tipsBody: '国际短信：英文和数字 160 字符/条，超出按 153 字符/条计费；含 Unicode 字符（中文等）70 字符/条，超出按 67 字符/条计费。以下 GSM 扩展字符按 2 个字符计费：| ^ € [ ] ~ \\。发送号码必须为：国码+手机号，如 85288888888',
  recipients: '接收号码',
  uploaded: '已上传',
  numberCount: '{n} 个号码',
  recipientsDesc: '输入手机号或上传号码文件；选择国家后，系统将按规则自动补全国码',
  countryLabel: '目标国家/地区',
  countryChina: '中国 (+86)',
  countryHK: '香港 (+852)',
  countryMO: '澳门 (+853)',
  countryTW: '台湾 (+886)',
  countryJP: '日本 (+81)',
  countryUS: '美国/加拿大 (+1)',
  countryIntl: '其他（手动带国码）',
  countryHintChina: '已选中国：可直接填写 11 位手机号（如 13800138000），无需加 86，系统自动补全',
  countryHint: '选择国家后，本地号码将自动补全国码；选「其他」时需手动填写完整国码+号码',
  phonePlaceholder: '输入手机号，回车添加',
  phonePlaceholderChina: '输入 11 位手机号，如 13800138000',
  phoneFormatHint: '格式必须为：国际区号 + 号码，如 85288888888，区号与号码之间不加0，多个号码之间用逗号分隔',
  phoneFormatHintChina: '中国号码可直接填 11 位手机号（1 开头），无需加 86；已带 86 的号码也可直接使用',
  phoneFormatHintLocal: '已选 {country}：可填写本地号码，系统自动补全国码',
  invalidPhoneKept: '以下号码不符合所选国家格式，已保留在输入框：{phones}',
  invalidPhonesFiltered: '已过滤 {n} 个号码（不符合所选国家格式，请检查国家选择）',
  uploadNumbers: '上传号码',
  uploadTooltip: '支持 TXT、CSV、Excel 格式；非数字内容会被自动过滤并去重',
  downloadTemplate: '下载模板',
  dropZoneText: '拖拽文件到此处，或',
  dropZoneLink: '点击上传',
  dropZoneHint: '支持 TXT / CSV / Excel，最大 50MB',
  dropZoneEncoding: '文件字符编码必须为 Unicode(UTF-8)；非数字内容会被自动过滤并去重',
  originalCount: '原号码 {n}',
  uniqueCount: '去重后 {n}',
  parsing: '解析中 {n}%...',
  uploadFailed: '上传失败',
  content: '短信内容',
  charCount: '{n}字',
  contentDesc: '编辑短信正文，支持变量插入；预估条数仅供参考，实际计费以运营商为准',
  contentLabel: '短信内容',
  contentPlaceholder: '请输入短信内容',
  variables: '变量',
  varGuideTitle: '变量使用说明',
  varGuide1: '1. 下载「变量模板」：第一列为手机号（表头须为 phone/手机号 等），其余列自动识别为变量，表头名即变量名',
  varGuide2: "2. 在短信内容中点击上方变量按钮或手动输入 {'{'}变量名{'}'}，如：尊敬的{'{'}name{'}'}您好",
  varGuide3: '3. 变量群发一次仅支持使用一个变量，且号码必须全部来自上传的文件（不支持手动输入的号码）',
  varGuide4: '4. 发送时系统按号码顺序逐一替换变量值，每个号码收到个性化内容',
  varFileDetected: '已识别文件变量列：{keys}',
  errVarNoFile: '短信内容使用了变量 {keys}，请先上传包含变量列的号码文件（可下载变量模板）',
  errVarUnknownKey: '变量 {keys} 在上传文件中不存在，请检查文件表头或修改短信内容',
  errVarOnlyOne: '一次发送仅支持一个变量，请仅保留一个变量占位符（当前：{keys}）',
  errVarManualPhone: '{n} 个号码非来自上传文件，变量群发仅支持文件中的号码，请移除手动输入的号码',
  errVarSchedule: '变量群发暂不支持定时发送，请关闭定时设置后直接发送',
  estimatedLength: '预估短信长度',
  estimatedSegments: '预估条数',
  segmentsUnit: '条',
  billingRules: '计费说明',
  billingTitle: '短信计费规则',
  billingRule1: '1. GSM字符集：单条160字，超出按153字/条分隔',
  billingRule2: '2. 扩展字符（|^€[]~\\）按2个字符计费',
  billingRule3: '3. Unicode字符（中文等）：单条70字，超出按67字/条分隔',
  billingRule4: '4. 预估条数仅供参考，实际以运营商计费为准',
  sendSettings: '发送设置',
  sendSettingsDesc: '配置号码追踪、Sender ID 和定时发送',
  phoneTrace: '号码追踪',
  trackContent: '转换后短信内容',
  trackEmpty: '输入 https:// 链接后会自动识别，并为每个号码进行一次链接转化',
  senderIdPlaceholder: '请输入 Sender ID',
  senderIdHint: 'Sender ID 即发送者ID，通常用于短信接收者看到的发送号码或字母，一般使用品牌英文字母',
  scheduleSend: '设置为定时发送任务',
  selectDate: '选择日期',
  timezoneHint: '按所选时区时间设置，服务器自动计算时差',
  timeTooEarly: '所选时间不能早于当前时区时间',
  agreement: '我已阅读并遵守',
  agreementLink: '《使用条款与隐私协议》',
  submitting: '提交中...',
  submit: '提交发送',
  preview: '预览',
  previewPlaceholder: '短信内容预览',
  justNow: '刚刚',
  length: '长度',
  segments: '条数',
  encoding: '编码',
  scheduled: '定时',
  instant: '即时',
  timezone: '时区',
  charsUnit: '字',
  templateModalTitle: '下载导入模板',
  templateModalDesc: '请选择需要下载的模板类型：',
  templatePlain: '非变量模板',
  templatePlainDesc: '仅包含手机号列，适用于群发相同内容',
  templateVar: '变量模板',
  templateVarDesc: '包含手机号和变量列，适用于个性化内容',
  agreementTitle: '使用条款与隐私协议',
  agreementIntro: '欢迎使用 {site} 短信服务平台。在使用本服务之前，请您仔细阅读以下条款：',
  agreementSection1: '一、服务说明',
  agreementSection1Body: '本平台为用户提供国际短信发送服务，包括但不限于验证码短信、营销短信等类型的短信发送。用户应确保所发送的短信内容合法合规，不含有违反法律法规的内容。',
  agreementSection2: '二、用户责任',
  agreementSection2Body1: '1. 用户应确保所发送的短信内容真实、合法，不得利用本平台发送垃圾短信、诈骗信息等违法内容。',
  agreementSection2Body2: '2. 用户应妥善保管账户信息，因用户自身原因导致账户泄露所造成的损失，由用户自行承担。',
  agreementSection2Body3: '3. 用户应按照平台规定的计费方式支付相关费用。',
  agreementSection3: '三、隐私保护',
  agreementSection3Body: '我们重视用户隐私保护，将按照隐私政策收集、使用和保护您的个人信息。未经您的同意，我们不会向第三方披露您的个人信息。',
  agreementSection4: '四、免责声明',
  agreementSection4Body: '因不可抗力、运营商网络故障等原因导致短信发送失败或延迟的，本平台不承担相关责任。',
  agreementConfirm: '我已知晓',
  errNoPhone: '请上传号码文件或者填入手机号',
  errNoContent: '请输入短信内容',
  errScheduleTooEarly: '定时发送时间不能早于当前时区时间',
  errUploadNotReady: '号码文件尚未解析完成，请稍候',
  errFileTooLarge: '文件大小不能超过 50MB',
  errUnsupportedFormat: '仅支持 TXT、CSV、Excel 格式',
  errNoValidPhones: '文件中未识别到有效手机号，请检查格式（国码+号码）',
  errNoValidPhonesChina: '文件中未识别到有效中国手机号，请填写 11 位 1 开头的号码',
  errTooManyPhones: '单次导入号码不能超过 5 万条',
  sendSuccess: '发送成功',
  sendSuccessBatch: '批量发送已提交，共 {n} 个号码',
  sendFailed: '发送失败',
  toastQueued: '已受理，共 {n} 条号码，正在后台排队发送，请稍后在短信搜索查看',
  toastQueuedBatch: '批量已受理，共 {n} 条号码，正在后台排队发送',
  toastCompleted: '发送成功，共 {n} 条',
  toastPartial: '发送完成：成功 {ok} 条，失败 {fail} 条',
  toastFailed: '发送失败，请检查号码或余额',
  tzBeijing: '北京 UTC+8',
  tzTokyo: '东京 UTC+9',
  tzSingapore: '新加坡 UTC+8',
  tzNewYork: '纽约 UTC-5',
  tzLosAngeles: '洛杉矶 UTC-8',
  tzLondon: '伦敦 UTC+0',
  tzBerlin: '柏林 UTC+1',
  tzSydney: '悉尼 UTC+11',
}

export const sendSmsEn = {
  tipsTitle: 'Tips',
  tipsBody: 'International SMS: English and numbers — 160 chars/message, then 153 chars/segment; Unicode (e.g. Chinese) — 70 chars/message, then 67 chars/segment. GSM extension chars (| ^ € [ ] ~ \\) count as 2. Numbers must be country code + number, e.g. 85288888888',
  recipients: 'Recipients',
  uploaded: 'Uploaded',
  numberCount: '{n} numbers',
  recipientsDesc: 'Enter phone numbers or upload a file. Country selection auto-adds the country code when needed',
  countryLabel: 'Target country/region',
  countryChina: 'China (+86)',
  countryHK: 'Hong Kong (+852)',
  countryMO: 'Macau (+853)',
  countryTW: 'Taiwan (+886)',
  countryJP: 'Japan (+81)',
  countryUS: 'US/Canada (+1)',
  countryIntl: 'Other (full country code)',
  countryHintChina: 'China selected: enter 11-digit mobile numbers (e.g. 13800138000) without 86 — we add it automatically',
  countryHint: 'Local numbers are auto-prefixed with the country code. Choose Other to enter the full international number',
  phonePlaceholder: 'Enter number, press Enter to add',
  phonePlaceholderChina: '11-digit mobile, e.g. 13800138000',
  phoneFormatHint: 'Format: country code + number, e.g. 85288888888. No leading 0 after country code. Separate multiple numbers with commas',
  phoneFormatHintChina: 'China: use 11-digit mobile (starts with 1) without 86; numbers already starting with 86 are also accepted',
  phoneFormatHintLocal: '{country} selected: enter local numbers; country code is added automatically',
  invalidPhoneKept: 'These numbers do not match the selected country format and remain in the input: {phones}',
  invalidPhonesFiltered: '{n} numbers were filtered out (they do not match the selected country format — please check the country selection)',
  uploadNumbers: 'Upload Numbers',
  uploadTooltip: 'Supports TXT, CSV, Excel. Non-numeric content is filtered and deduplicated',
  downloadTemplate: 'Download Template',
  dropZoneText: 'Drag file here, or',
  dropZoneLink: 'click to upload',
  dropZoneHint: 'TXT / CSV / Excel, max 50MB',
  dropZoneEncoding: 'File must be UTF-8 encoded. Non-numeric content is filtered and deduplicated',
  originalCount: 'Original {n}',
  uniqueCount: 'Unique {n}',
  parsing: 'Parsing {n}%...',
  uploadFailed: 'Upload failed',
  content: 'Message Content',
  charCount: '{n} chars',
  contentDesc: 'Edit message body. Variable insertion supported. Segment count is estimated; actual billing depends on carrier',
  contentLabel: 'Message Content',
  contentPlaceholder: 'Enter message content',
  variables: 'Variables',
  varGuideTitle: 'How to Use Variables',
  varGuide1: '1. Download the Variable Template: first column is phone numbers (header: phone/mobile etc.); other columns are auto-detected as variables named by their headers',
  varGuide2: "2. Click a variable chip above or type {'{'}varname{'}'} in the content, e.g. Dear {'{'}name{'}'}",
  varGuide3: '3. Variable sending supports ONE variable per send, and all numbers must come from the uploaded file (manual input is not supported)',
  varGuide4: '4. Values are substituted per number in order — every recipient gets a personalized message',
  varFileDetected: 'Detected variable columns: {keys}',
  errVarNoFile: 'Content uses variable {keys}. Please upload a number file with variable columns (see the Variable Template)',
  errVarUnknownKey: 'Variable {keys} not found in the uploaded file. Check the file headers or edit the content',
  errVarOnlyOne: 'Only one variable per send. Keep a single placeholder (found: {keys})',
  errVarManualPhone: '{n} number(s) are not from the uploaded file. Variable sending supports file numbers only — remove manually entered numbers',
  errVarSchedule: 'Variable sending does not support scheduled send yet. Disable scheduling and send immediately',
  estimatedLength: 'Estimated length',
  estimatedSegments: 'Estimated segments',
  segmentsUnit: '',
  billingRules: 'Billing Info',
  billingTitle: 'SMS Billing Rules',
  billingRule1: '1. GSM: 160 chars per message, then 153 chars per segment',
  billingRule2: '2. Extension chars (|^€[]~\\) count as 2 chars',
  billingRule3: '3. Unicode (e.g. Chinese): 70 chars per message, then 67 chars per segment',
  billingRule4: '4. Segment count is estimated; actual billing depends on carrier',
  sendSettings: 'Send Settings',
  sendSettingsDesc: 'Configure link tracking, Sender ID, and scheduled send',
  phoneTrace: 'Link Tracking',
  trackContent: 'Converted Message',
  trackEmpty: 'Enter an https:// link to auto-detect and convert links per recipient',
  senderIdPlaceholder: 'Enter Sender ID',
  senderIdHint: 'Sender ID is shown to recipients as the sender name or number, usually brand letters',
  scheduleSend: 'Schedule for later',
  selectDate: 'Select date',
  timezoneHint: 'Set time in selected timezone; server handles offset automatically',
  timeTooEarly: 'Selected time cannot be earlier than current time in this timezone',
  agreement: 'I have read and agree to the',
  agreementLink: 'Terms of Service & Privacy Policy',
  submitting: 'Submitting...',
  submit: 'Send SMS',
  preview: 'Preview',
  previewPlaceholder: 'Message preview',
  justNow: 'Just now',
  length: 'Length',
  segments: 'Segments',
  encoding: 'Encoding',
  scheduled: 'Scheduled',
  instant: 'Instant',
  timezone: 'Timezone',
  charsUnit: 'chars',
  templateModalTitle: 'Download Import Template',
  templateModalDesc: 'Select a template type:',
  templatePlain: 'Plain Template',
  templatePlainDesc: 'Phone numbers only — for bulk identical messages',
  templateVar: 'Variable Template',
  templateVarDesc: 'Phone numbers + variables — for personalized messages',
  agreementTitle: 'Terms of Service & Privacy Policy',
  agreementIntro: 'Welcome to {site}. Please read the following terms before using this service:',
  agreementSection1: '1. Service Description',
  agreementSection1Body: 'This platform provides international SMS services including OTP and marketing messages. You must ensure all content is legal and compliant.',
  agreementSection2: '2. User Responsibilities',
  agreementSection2Body1: '1. You must ensure message content is truthful and legal. Spam, fraud, or illegal content is prohibited.',
  agreementSection2Body2: '2. Keep your account credentials secure. Losses from credential leaks are your responsibility.',
  agreementSection2Body3: '3. Pay fees according to the platform billing rules.',
  agreementSection3: '3. Privacy',
  agreementSection3Body: 'We protect your personal information per our privacy policy and will not disclose it to third parties without consent.',
  agreementSection4: '4. Disclaimer',
  agreementSection4Body: 'We are not liable for delivery failures or delays caused by force majeure or carrier network issues.',
  agreementConfirm: 'I Understand',
  errNoPhone: 'Please upload a number file or enter phone numbers',
  errNoContent: 'Please enter message content',
  errScheduleTooEarly: 'Scheduled time cannot be earlier than current time in this timezone',
  errUploadNotReady: 'Number file is still being parsed, please wait',
  errFileTooLarge: 'File size cannot exceed 50MB',
  errUnsupportedFormat: 'Only TXT, CSV, and Excel formats are supported',
  errNoValidPhones: 'No valid phone numbers found. Use country code + number format',
  errNoValidPhonesChina: 'No valid China mobile numbers found. Use 11-digit numbers starting with 1',
  errTooManyPhones: 'Cannot import more than 50,000 numbers at once',
  sendSuccess: 'Sent successfully',
  sendSuccessBatch: 'Batch submitted, {n} numbers in total',
  sendFailed: 'Send failed',
  toastQueued: 'Accepted: {n} number(s) queued for sending. Check SMS Search for progress',
  toastQueuedBatch: 'Batch accepted: {n} numbers queued for sending',
  toastCompleted: 'Sent successfully, {n} number(s)',
  toastPartial: 'Done: {ok} succeeded, {fail} failed',
  toastFailed: 'Send failed. Check numbers or balance',
  tzBeijing: 'Beijing UTC+8',
  tzTokyo: 'Tokyo UTC+9',
  tzSingapore: 'Singapore UTC+8',
  tzNewYork: 'New York UTC-5',
  tzLosAngeles: 'Los Angeles UTC-8',
  tzLondon: 'London UTC+0',
  tzBerlin: 'Berlin UTC+1',
  tzSydney: 'Sydney UTC+11',
}

export const sendSmsJa = {
  tipsTitle: 'ヒント',
  tipsBody: '国際SMS：英数字は160文字/通、超過分は153文字/通。Unicode（中国語等）は70文字/通、超過分は67文字/通。GSM拡張文字（| ^ € [ ] ~ \\）は2文字として計算。番号形式：国コード+番号（例：85288888888）',
  recipients: '受信番号',
  uploaded: 'アップロード済み',
  numberCount: '{n} 件',
  recipientsDesc: '電話番号を入力するか、ファイルをアップロード。国を選ぶと国コードを自動付与します',
  countryLabel: '対象国/地域',
  countryChina: '中国 (+86)',
  countryHK: '香港 (+852)',
  countryMO: 'マカオ (+853)',
  countryTW: '台湾 (+886)',
  countryJP: '日本 (+81)',
  countryUS: '米国/カナダ (+1)',
  countryIntl: 'その他（国コード付きで入力）',
  countryHintChina: '中国選択時：11桁の携帯番号（例 13800138000）を 86 なしで入力可能。自動で付与します',
  countryHint: '国選択後、ローカル番号に国コードを自動付与。「その他」は国コード+番号を入力',
  phonePlaceholder: '番号を入力し、Enterで追加',
  phonePlaceholderChina: '11桁の携帯番号、例 13800138000',
  phoneFormatHint: '形式：国コード+番号（例：85288888888）。国コード後に0を付けない。複数はカンマ区切り',
    phoneFormatHintChina: '中国：11桁（1始まり）を 86 なしで入力可。86 付き番号も利用可',
    phoneFormatHintLocal: '{country} 選択中：ローカル番号可。国コードは自動付与',
    invalidPhoneKept: '次の番号は選択した国の形式に合わないため入力欄に残しました：{phones}',
    invalidPhonesFiltered: '{n} 件の番号を除外しました（選択した国の形式に合わないため、国選択をご確認ください）',
  uploadNumbers: '番号アップロード',
  uploadTooltip: 'TXT、CSV、Excel対応。非数字は自動フィルタ・重複除去',
  downloadTemplate: 'テンプレートDL',
  dropZoneText: 'ファイルをドラッグ、または',
  dropZoneLink: 'クリックしてアップロード',
  dropZoneHint: 'TXT / CSV / Excel、最大50MB',
  dropZoneEncoding: 'UTF-8エンコード必須。非数字は自動フィルタ・重複除去',
  originalCount: '元 {n}',
  uniqueCount: '重複除去後 {n}',
  parsing: '解析中 {n}%...',
  uploadFailed: 'アップロード失敗',
  content: 'SMS内容',
  charCount: '{n}文字',
  contentDesc: '本文を編集。変数挿入対応。通数は参考値、実際の課金はキャリア基準',
  contentLabel: 'SMS内容',
  contentPlaceholder: 'SMS内容を入力',
  variables: '変数',
  varGuideTitle: '変数の使い方',
  varGuide1: '1. 「変数テンプレート」をダウンロード：1列目は電話番号（ヘッダー：phone/携帯番号 など）、他の列はヘッダー名の変数として自動認識',
  varGuide2: "2. 上の変数ボタンをクリック、または本文に {'{'}変数名{'}'} を入力（例：{'{'}name{'}'} 様）",
  varGuide3: '3. 変数送信は1回につき1つの変数のみ対応。番号はすべてアップロードファイルのものを使用（手入力不可）',
  varGuide4: '4. 番号順に変数値を置換し、各受信者にパーソナライズされた内容が届きます',
  varFileDetected: 'ファイルの変数列を検出：{keys}',
  errVarNoFile: '内容で変数 {keys} を使用しています。変数列を含む番号ファイルをアップロードしてください（変数テンプレートを参照）',
  errVarUnknownKey: '変数 {keys} はアップロードファイルに存在しません。ファイルのヘッダーまたは内容を確認してください',
  errVarOnlyOne: '1回の送信で使用できる変数は1つです。プレースホルダーを1つにしてください（現在：{keys}）',
  errVarManualPhone: '{n} 件の番号がアップロードファイル以外のものです。変数送信はファイル内の番号のみ対応。手入力番号を削除してください',
  errVarSchedule: '変数送信は予約送信に未対応です。予約設定をオフにして即時送信してください',
  estimatedLength: '推定文字数',
  estimatedSegments: '推定通数',
  segmentsUnit: '通',
  billingRules: '課金説明',
  billingTitle: 'SMS課金ルール',
  billingRule1: '1. GSM：160文字/通、超過分153文字/通',
  billingRule2: '2. 拡張文字（|^€[]~\\）は2文字として計算',
  billingRule3: '3. Unicode：70文字/通、超過分67文字/通',
  billingRule4: '4. 通数は参考値、実際の課金はキャリア基準',
  sendSettings: '送信設定',
  sendSettingsDesc: 'リンク追跡、Sender ID、予約送信の設定',
  phoneTrace: 'リンク追跡',
  trackContent: '変換後の内容',
  trackEmpty: 'https:// リンクを入力すると自動認識し、番号ごとに変換',
  senderIdPlaceholder: 'Sender IDを入力',
  senderIdHint: 'Sender IDは受信者に表示される送信者名または番号',
  scheduleSend: '予約送信に設定',
  selectDate: '日付を選択',
  timezoneHint: '選択したタイムゾーンで設定、サーバーが時差を自動計算',
  timeTooEarly: '選択時刻は現在のタイムゾーン時刻より前にできません',
  agreement: '以下に同意します：',
  agreementLink: '利用規約とプライバシーポリシー',
  submitting: '送信中...',
  submit: 'SMS送信',
  preview: 'プレビュー',
  previewPlaceholder: 'SMSプレビュー',
  justNow: 'たった今',
  length: '文字数',
  segments: '通数',
  encoding: 'エンコード',
  scheduled: '予約',
  instant: '即時',
  timezone: 'タイムゾーン',
  charsUnit: '文字',
  templateModalTitle: 'インポートテンプレートDL',
  templateModalDesc: 'テンプレートタイプを選択：',
  templatePlain: '通常テンプレート',
  templatePlainDesc: '電話番号のみ — 一括同一内容向け',
  templateVar: '変数テンプレート',
  templateVarDesc: '電話番号+変数 — パーソナライズ向け',
  agreementTitle: '利用規約とプライバシーポリシー',
  agreementIntro: '{site} へようこそ。ご利用前に以下の条項をお読みください：',
  agreementSection1: '1. サービス説明',
  agreementSection1Body: '本プラットフォームはOTP・マーケティングSMS等の国際SMS送信サービスを提供します。内容は法令遵守である必要があります。',
  agreementSection2: '2. ユーザー責任',
  agreementSection2Body1: '1. 送信内容は真実かつ合法であること。スパム・詐欺等の違法内容は禁止。',
  agreementSection2Body2: '2. アカウント情報を適切に管理。漏洩による損失はユーザー責任。',
  agreementSection2Body3: '3. プラットフォームの課金方式に従い料金を支払うこと。',
  agreementSection3: '3. プライバシー',
  agreementSection3Body: 'プライバシーポリシーに従い個人情報を保護し、同意なく第三者に開示しません。',
  agreementSection4: '4. 免責事項',
  agreementSection4Body: '不可抗力・キャリア障害による送信失敗・遅延について当社は責任を負いません。',
  agreementConfirm: '了解しました',
  errNoPhone: '番号ファイルをアップロードするか、電話番号を入力してください',
  errNoContent: 'SMS内容を入力してください',
  errScheduleTooEarly: '予約時刻は現在のタイムゾーン時刻より前にできません',
  errUploadNotReady: '番号ファイルの解析が完了していません。しばらくお待ちください',
  errFileTooLarge: 'ファイルサイズは50MB以下にしてください',
  errUnsupportedFormat: 'TXT、CSV、Excel形式のみ対応しています',
  errNoValidPhones: '有効な電話番号が見つかりません。国コード+番号形式を確認してください',
  errNoValidPhonesChina: '有効な中国の携帯番号が見つかりません。1で始まる11桁を入力してください',
  errTooManyPhones: '一度にインポートできる番号は5万件までです',
  sendSuccess: '送信成功',
  sendSuccessBatch: '一括送信を受け付けました（{n} 件）',
  sendFailed: '送信失敗',
  toastQueued: '受付済み：{n} 件をバックグラウンド送信キューに追加しました。SMS検索で進捗を確認',
  toastQueuedBatch: '一括受付：{n} 件をバックグラウンド送信キューに追加しました',
  toastCompleted: '送信成功：{n} 件',
  toastPartial: '完了：成功 {ok} 件、失敗 {fail} 件',
  toastFailed: '送信失敗。番号または残高を確認してください',
  tzBeijing: '北京 UTC+8',
  tzTokyo: '東京 UTC+9',
  tzSingapore: 'シンガポール UTC+8',
  tzNewYork: 'ニューヨーク UTC-5',
  tzLosAngeles: 'ロサンゼルス UTC-8',
  tzLondon: 'ロンドン UTC+0',
  tzBerlin: 'ベルリン UTC+1',
  tzSydney: 'シドニー UTC+11',
}
